import request from 'config/apiConfig';

export const getVideoList = (payload: { marketerId: string; page: number; size?: number; search?: string }) => {
  return request.get(`playlist/contents/marketer`, {
    params: {
      id: payload.marketerId,
      status: 'APPROVED',
      size: payload.size ? payload.size : 12,
      sort: 'created,desc',
      page: payload.page,
      q: payload.search || undefined
    }
  });
};

export const putUploadContent = (id: string, data: any) => {
  return request.put(`playlist/contents/${id}/info`, data);
};

export const putUploadTags = (id: string, data: any) => {
  return request.put(`playlist/contents/${id}/tags`, data);
};

export const getStreamsByChannel = (channelId: string) => {
  return request.get(`channel/streams/channel`, {
    params: { id: channelId, size: 1000, sort: 'created,desc' }
  });
};

export const getPlacementsByStream = (streamnId: string) => {
  return request.get(`channel/placements/stream`, {
    params: { id: streamnId, size: 1000, sort: 'created,desc' }
  });
};

export const getChannelsByMarketer = (marketerId: string) => {
  return request.get(`channel/channels/marketer`, {
    params: { id: marketerId, size: 1000, sort: 'created,desc' }
  });
};

export const putUpdateCTA = (id: string, ctaId: string) => {
  return request.put(`playlist/contents/${id}/cta`, { cta: ctaId });
};

export const putUpdatePlacementTags = (id: string, tags: string[]) => {
  return request.put(`channel/placements/${id}/tags`, { tags: tags });
};

export const deleteVideo = (id: string) => {
  return request.delete(`playlist/contents/${id}`);
};

export const getTagsByMarketer = () => {
  return request.get(`playlist/tags`, {});
};

export const postConversionToCTA = (data: any) => {
  return request.post(`/conversion/ctas`, data);
};

export const fetchAllVideos = (payload: { marketerId: string }) => {
  return request.get(`playlist/contents/marketer`, {
    params: {
      id: payload.marketerId,
      status: 'APPROVED',
      size: 1000,
      sort: 'created,desc',
      page: 0
    }
  });
};

export const getPlaylistByPlacementId = (placementId: string) => {
  return request.get(`playlist/playlists/placement`, {
    params: { id: placementId }
  });
};

export const createPlaylist = (data: { name: string; marketer: string }) => {
  return request.post(`playlist/playlists`, data);
};

export const linkPlacementsToPlaylist = (playlistId: string, data: { placements: string[] }) => {
  return request.put(`playlist/playlists/${playlistId}/placements`, data);
};

export const getContentsByPlaylist = (payload: {
  playlistId: string;
  status?: string;
  page?: number;
  size?: number;
}) => {
  return request.get(`playlist/contents/playlist`, {
    params: {
      id: payload.playlistId,
      status: payload.status || 'APPROVED',
      page: payload.page || 0,
      size: payload.size || 12,
      sort: 'pin,asc'
    }
  });
};

export const linkPlaylistsToContent = (contentId: string, data: { playlists: string[] }) => {
  return request.put(`playlist/contents/${contentId}/playlists`, data);
};

export const unlinkContentFromPlaylist = (contentId: string, playlistId: string) => {
  return request.delete(`playlist/contents/${contentId}/playlist`, {
    params: { id: playlistId }
  });
};

export const fetchAssetDetails = (assetId: string) => {
  return request.get(`content/assets/content/${assetId}`);
};

export const reorderPlaylistContent = (playlistId: string, fromIndex: number, toIndex: number) => {
  return request.put(`playlist/playlists/${playlistId}/reorder`, null, {
    params: { from: fromIndex, to: toIndex }
  });
};

export const pinContentToPlaylist = (playlistId: string, data: { contentId: string; forced: boolean }) => {
  return request.put(`playlist/playlists/${playlistId}/pin`, data);
};

export const unpinContentFromPlaylist = (playlistId: string, contentId: string) => {
  return request.delete(`playlist/playlists/${playlistId}/pin`, {
    params: { contentId }
  });
};

export const fetchPinnedPlaylistContent = (playlistId: string) => {
  return request.get(`playlist/playlists/${playlistId}/contents`);
};

export const fetchUnpinnedPlaylistContent = (playlistId: string, page?: string) => {
  return request.get(`playlist/contents/playlist`, {
    params: {
      id: playlistId,
      status: 'APPROVED',
      size: 50,
      page: page
    }
  });
};

export const searchVideos = (playlistId: string, keyword?: string) => {
  return request.get(`playlist/contents/playlist/search`, {
    params: {
      id: playlistId,
      q: keyword
    }
  });
};

export const removePinnedContentFromPlaylist = (playlistId: string, contentId: string) => {
  return request.delete(`playlist/playlists/${playlistId}/pin`, {
    params: {
      contentId: contentId
    }
  });
};
